import { formatCurrency, formatDate } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const SAVTab = ({ savData }) => (
  <div className="space-y-4">
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>SAV assignés</CardTitle>
        <Badge variant="outline" className="text-base">{formatCurrency(savData.total_cost)} cumulé</Badge>
      </CardHeader>
      <CardContent>
        {savData.savs.length === 0 ? <p className="text-center text-muted-foreground py-4">Aucun SAV assigné.</p> : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Client</TableHead>
                <TableHead>Description</TableHead>
                <TableHead>Commande</TableHead>
                <TableHead>Date</TableHead>
                <TableHead>Coût</TableHead>
                <TableHead>Statut</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {savData.savs.map(s => (
                <TableRow key={s.id}>
                  <TableCell className="font-medium">{s.client_name}</TableCell>
                  <TableCell className="max-w-[200px] truncate">{s.description}</TableCell>
                  <TableCell>{s.order_reference ? <Badge variant="outline" className="font-mono text-xs">{s.order_reference}</Badge> : "-"}</TableCell>
                  <TableCell>{formatDate(s.intervention_date)}</TableCell>
                  <TableCell className="font-mono font-bold">{formatCurrency(s.cost)}</TableCell>
                  <TableCell><Badge variant="outline">{s.status}</Badge></TableCell>
                </TableRow>
              ))}
              <TableRow className="bg-muted/50">
                <TableCell colSpan={4} className="font-bold text-right">Total cumulé</TableCell>
                <TableCell className="font-mono font-bold text-primary">{formatCurrency(savData.total_cost)}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  </div>
);

export default SAVTab;
